import Vue from 'vue';
import Router from 'vue-router';
import Layout from '../layout/Layout.vue';
import Login from '../views/Login.vue';
import Dashboard from '../views/Dashboard.vue';
import Users from '../views/Users.vue';
import Recharges from '../views/Recharges.vue';
import Withdraws from '../views/Withdraws.vue';
import Commission from '../views/Commission.vue';
import Settlements from '../views/Settlements.vue';
import { getToken } from '../store';

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  routes: [
    { path: '/login', component: Login },
    {
      path: '/',
      component: Layout,
      redirect: '/dashboard',
      children: [
        { path: 'dashboard', component: Dashboard, meta: { titleKey: 'menu.dashboard' } },
        { path: 'users', component: Users, meta: { titleKey: 'menu.users' } },
        { path: 'recharges', component: Recharges, meta: { titleKey: 'menu.recharges' } },
        { path: 'withdraws', component: Withdraws, meta: { titleKey: 'menu.withdraws' } },
        { path: 'commission', component: Commission, meta: { titleKey: 'menu.commission' } },
        { path: 'settlements', component: Settlements, meta: { titleKey: 'menu.settlements' } }
      ]
    },
    { path: '*', redirect: '/dashboard' }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.path !== '/login' && !getToken()) {
    next('/login');
    return;
  }
  if (to.path === '/login' && getToken()) {
    next('/dashboard');
    return;
  }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js